export const permissions = Object.freeze({
    review: 'Review',
    judgeDesignRevision: 'JudgeDesignRevision',
    grant: 'Grant',
    readDataInsights: 'read:data-insights',
    design: 'Design',
    listAllTreatments: 'ListAllTreatments',
    delivery: 'DeliverTreatmentFiles',
    editTreatmentNote: 'EditTreatmentNote',
    export: 'Export',
    markRedesign: 'MarkRedesign',
    uploadTreatmentReturnImagesToDesignService: 'UploadTreatmentReturnImagesToDesignService',
    replyTreatmentQuestion: 'ReplyTreatmentQuestion',
    updateTreatmentQuestionAssignee: 'UpdateTreatmentQuestionAssignee',
    answerTreatmentQuestion: 'AnswerTreatmentQuestion',
    assignDesigner: 'AssignDesigner',
    assignTreatmentDemoVideoEditor: 'AssignTreatmentDemoVideoEditor',
    editTreatmentDemoVideo: 'EditTreatmentDemoVideo',
    writeDoctorPreference: 'write:doctor-preference',
    translate: 'Translate',
    manageAppSettings: 'manage:app-settings',
    markExpedited: 'MarkExpedited',
    manageTreatmentMessageTemplates: 'manage:treatment-message-templates',
    readQCChecklistTemplates: 'read:qc-checklist-templates',
    manageQCChecklistTemplates: 'manage:qc-checklist-templates',
    readRequiredDesignFileTemplates: 'read:required-design-file-templates',
    manageRequiredDesignFileTemplates: 'manage:required-design-file-templates',
    readTreatmentTypeGroups: 'read:treatment-type-groups',
    manageTreatmentTypeGroups: 'manage:treatment-type-groups',
    readRoster: 'read:roster',
    writeRoster: 'write:roster',
    readTreatmentAssignRule: 'read:treatment-assign-rule',
    writeTreatmentAssignRule: 'write:treatment-assign-rule',
    writeDesignRevisionReason: 'write:design-revision-reason',
});
